<template>
  <div class="media-gallery" :class="[{'display': display}]" ref="gallery">
    <div class="container gallery-container">
      <div class="row">
        <div class="col-xs-12">
          <carousel
            :perPage="1"
            :scrollPerPage="true"
            :paginationEnabled="false"
            :navigationEnabled="true"
            :navigationNextLabel="'<div>›</div>'"
            :navigationPrevLabel="'<div>‹</div>'"
            :loop="true"
            :navigateTo="[index, false]"
            @pageChange="pageChange"
            ref="carousel"
            class="media-slider"
          >
           <slide
              :class="`${medium.type==='Photo' ? 'slide-container' : 'video-slider-container'}`"
              v-for="(medium, mediumIndex) in media"
              :key="mediumIndex"
            >
              <div>                
                <div v-if="medium.type==='Video'" class="video-container">
                  <div class="stock-video">
                    <iframe class="embed-video" :src="videoUrl(medium.youtubeMrId)" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                  </div>
                </div>
                <div v-else-if="medium.type==='Photo'" class="slide-content">
                  <img :src="photoUrl(medium.src)">
                </div>
                <div v-else-if="medium.type==='Vr'" class="video-container">
                  <div class="stock-vr" :data-script="medium.script" @click="loadVr">
                    <img :src="medium.thumbnail" />
                    <img src="/ics/property/img/details/vr-01.svg" class="play-icon" />
                  </div>
                </div>
              </div>
            </slide>
            
          </carousel>
          <img 
            class="close-button" 
            src="/ics/property/img/templates/logo_svg/close_white.svg"
            @click="$emit('close')"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Carousel, Slide } from 'vue-carousel';
  
  export default {
    props: ['display', 'index', 'media'],
    components: {
      Carousel,
      Slide,
    },
    data() {
      return {
        currentIndex: 0,
      }
    },
    watch: {
      display(val) {
        if (val) {
          window.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
              this.$emit('close');
            }
          });
        }
      },
    },
    computed: {
  
    },
    methods: {
      videoUrl(id) {
        return `https://www.youtube.com/embed/${id}`;
      },
      photoUrl(root) {
        return `${root}/m.jpeg`
      },
      pageChange(i) {
        this.currentIndex = i;
      },
      loadVr(event){
        const vrDom = event.currentTarget;
        vrDom.innerHTML = vrDom.getAttribute('data-script');
      },
    },
  };
</script>

<style scoped>
.media-gallery {
  position: fixed;
  z-index: 999999;
  overflow: hidden;
  background: rgba(0,0,0,.9);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: none;
}

.media-gallery.display {
  display: flex;
}

.gallery-container {
  align-self: center;
}

.close-button {
  width: 60px;
  height: 60px;
  position: absolute;
  top: 0px;
  right: 0px;
}

.media-slider {
  width: 100%;
  height: 100%;
}

.slide-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.slide-content {
  align-self: center;
}

.video-container {
  padding-left: 10%;
  padding-right: 10%;
}

.video-slider-container {
  align-self: center;
}

.stock-video, .stock-vr {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  text-align: center;
}

.stock-vr > img {
  width: 100%;
}

.stock-vr > img.play-icon {
  width: 30%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);  
}

.embed-video, >>> .stock-vr > iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}


@media screen and (max-width:991px) {
  .container {
    width: 100%;
  }
  
  .slide-content img {
    width: 100%;
    height: auto;
  }
  
  .close-button {
    top: -40px;
    right: 0px;
  }
}

@media screen and (max-width:991px) and (orientation:landscape) {
  .container {
    width: 100%;
  }
  
  .slide-content img {
    width: auto;
    height: 100vh;
  }
  
  .close-button {
    top: 0px;
    right: 0px;
  }
}
</style>

<style>
.media-slider.VueCarousel > .VueCarousel-navigation > button.VueCarousel-navigation-button.VueCarousel-navigation-prev {
  left: 0px !important;
  padding: 0 !important;
}

.media-slider.VueCarousel > .VueCarousel-navigation > button.VueCarousel-navigation-button.VueCarousel-navigation-next {
  right: 0px !important;
  padding: 0 !important;
}

.media-slider.VueCarousel > .VueCarousel-navigation > button.VueCarousel-navigation-button > div {
  color: #FFFFFF;
  font-size: 60px;
}

.media-slider.VueCarousel > .VueCarousel-wrapper {
  margin: auto;
}
</style>
